module.exports = __webpack_public_path__ + "fonts/1c164451-034c-41f5-9542-390709016510.2622f6b5.woff";